import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const uploadNewsImageApi = usersApi.injectEndpoints({
  endpoints: (builder: any) => ({
    uploadNewsImage: builder.mutation({
      query: (form: any) => ({
        url: '/news-pages/admin/upload-file/',
        method: 'POST',
        body: form,
      }),
      headers: {
        'content-type': 'multipart/form-data',
      },
      invalidatesTags: (result: { data: { file_path: string } }, error: any, arg: any) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useUploadNewsImageMutation } = uploadNewsImageApi;
